export default "__VITE_ASSET__CXMmQSQp__"